/* eslint-disable react/forbid-component-props */
import classnames from 'classnames';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

import { Scrollbars } from './Scrollbars';
import {
  renderTrackHorizontalDefault,
  renderTrackVerticalDefault,
} from './Scrollbars/Scrollbars/defaultRenderElements';
import ScrollBarWidth from '../../utils/ScrollBarWidth';

const headerZindex = 101;
const DEBOUNCE_TIME = 300;

class Scroll extends PureComponent {
  static propTypes = {
    autoHeightMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    passProps: PropTypes.object,
    classNameInner: PropTypes.string,
    getRef: PropTypes.func,
    tagName: PropTypes.string,
    className: PropTypes.string,
    isOpen: PropTypes.bool,
    onScroll: PropTypes.func,
  };

  static defaultProps = {
    autoHeightMax: null,
    passProps: null,
    classNameInner: '',
    getRef: null,
    tagName: 'div',
    className: '',
    isOpen: false,
    onScroll: null,
  };

  constructor(props) {
    super(props);

    this.scrollBarWidthUtil = new ScrollBarWidth();
  }

  state = {
    scrollbarWidth: 0,
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.widthCalculated = false;
    this.calculateScrollWidth();
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.view.scrollTop = 0;
    }
    this.calculatesWidthDebounced(true);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  widthCalculated = false;

  calculateScrollWidth = (shouldBeFinished = false) => {
    if (this.view.offsetWidth > 0 && !this.widthCalculated) {
      const { scrollbarWidth: oldScrollbarWidth } = this.state;
      const scrollbarWidth = this.view.offsetWidth - this.view.clientWidth;

      if (scrollbarWidth && scrollbarWidth !== oldScrollbarWidth) {
        this.scrollBarWidthUtil.width = scrollbarWidth;
        this.setState({ scrollbarWidth });
        if (shouldBeFinished && scrollbarWidth) {
          this.widthCalculated = true;
        }
      }
    }
  };

  calculatesWidthDebounced = debounce(this.calculateScrollWidth, DEBOUNCE_TIME);

  onResize = (...args) => {
    this.widthCalculated = false;
    this.calculatesWidthDebounced(...args);
  };

  addZindex = func => ({ style, ...props }) =>
    func({
      style: { ...style, zIndex: this.panelsZindex },
      ...props,
    });

  renderView = ({ style, ...props }) => {
    const {
      tagName: Tag,
      classNameInner,
      passProps,
      autoHeightMax,
    } = this.props;

    const { scrollbarWidth } = this.state;

    return (
      <Tag
        {...props}
        {...passProps}
        className={classnames(classNameInner, 'hideScrollbars')}
        style={{
          ...style,
          maxHeight: autoHeightMax,
          marginRight: scrollbarWidth ? -scrollbarWidth : 0,
          marginBottom: scrollbarWidth ? -scrollbarWidth : 0,
          scrollbarWidth: `none`,
        }}
      />
    );
  };

  viewRef = el => {
    if (!el) {
      return;
    }

    this.view = el.view;

    this.panelsZindex =
      (parseInt(getComputedStyle(el.view).zIndex) || headerZindex) + 1;

    const { getRef } = this.props;
    getRef && getRef(el.view);
  };

  handleScroll = event => {
    const { onScroll } = this.props;
    onScroll && onScroll(event);
  };

  render() {
    const {
      passProps,
      tagName,
      classNameInner,
      getRef,
      className,
      isOpen,
      onScroll,
      ...props
    } = this.props;

    return (
      <Scrollbars
        ref={this.viewRef}
        autoHeight
        autoHide
        universal
        className={classnames(className, { open: isOpen })}
        renderTrackHorizontal={this.addZindex(renderTrackHorizontalDefault)}
        renderTrackVertical={this.addZindex(renderTrackVerticalDefault)}
        renderView={this.renderView}
        scrollBarWidthUtil={this.scrollBarWidthUtil}
        onScroll={this.handleScroll}
        {...props}
      />
    );
  }
}

export default Scroll;
